<template>
  <div
    class="text-center space-y-3 mt-6 py-6 sm:py-10 bg-gray-100 dark:bg-gray-800 transition-colors"
  >
    <h1
      class="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-gray-900 dark:text-white"
    >
      Ready to find better Odds?
    </h1>
    <p class="text-base md:text-xl text-gray-600 dark:text-gray-300 mt-2">
      Join thousands of smart bettors<br />
      using Ask Odds to maximise returns
    </p>
  </div>
</template>

<script setup lang="ts"></script>
